import { useEffect } from "react";

interface MetaInput {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
}

/** 注入/更新页面级 SEO 标签与 JSON-LD 结构化数据 */
export function usePageMeta({ title, description, keywords }: MetaInput) {
  useEffect(() => {
    document.title = title;

    const setOrCreateMeta = (name: string, content: string, attr: "name" | "property" = "name") => {
      if (!content) return;
      let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setOrCreateMeta("description", description ?? "");
    setOrCreateMeta("keywords", keywords ?? "");
    setOrCreateMeta("og:title", title, "property");
    setOrCreateMeta("og:description", description ?? "", "property");
  }, [title, description, keywords]);
}

/** 注入一份 JSON-LD 结构化数据，同 id 不重复 */
export function useJsonLd(id: string, data: object | null) {
  useEffect(() => {
    if (!data) return;
    const existing = document.getElementById(`jsonld-${id}`);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = `jsonld-${id}`;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      document.getElementById(`jsonld-${id}`)?.remove();
    };
  }, [id, JSON.stringify(data ?? null)]);
}